import React from 'react'
import {Button, Flex, Image, Text, useStyleConfig, useBreakpointValue} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {getDamImageUrl, getGlobalLink, safeBuildUrl} from '../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {Link} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PaperlessBanner = ({title, description, button, image}) => {
    const styles = useStyleConfig('PaperlessBanner')
    const categoriesData = useGetCategoriesData()
    const {url, label, isAbsolute} = getGlobalLink({link: button, categoriesData})

    const damImageUrl = useBreakpointValue({
        base: image?.mobile,
        lg: image?.desktop,
    })
    const {buildUrl} = useMultiSite()
    const imageUrl = getDamImageUrl(damImageUrl)

    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(url, buildUrl),
          }

    return (
        <Flex {...styles.bannerOuterContainer}>
            <Flex {...styles.bannerInnerContainer}>
                {imageUrl && <Image src={imageUrl} {...styles.bannerImage} />}
                <Flex {...styles.bannerTextStack}>
                    <Text {...styles.bannerTitle}>{title}</Text>
                    <Text {...styles.bannerDescription}>{description}</Text>
                    <Button {...buttonProps} {...styles.bannerButton} variant={'inverse-primary'}>
                        {label}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    )
}

PaperlessBanner.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    button: PropTypes.object,
    image: PropTypes.shape(),
}

export default PaperlessBanner
